export default __webpack_public_path__ + "static/media/Skirt of the Hell Walker.597da53b.jpg";